import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download, Eye, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, downloadFile } from "@/lib/api";

function PdfDialog({ path, title, filename, onClose }) {
  const [pages, setPages] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(path.replace(/\/pdf$/, "/preview")).then((r) => setPages(r.data.pages)).catch((e) => setErr(errMsg(e)));
  }, [path]);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="glass flex h-[90vh] max-w-5xl flex-col" data-testid="pdf-preview-dialog">
        <DialogHeader><DialogTitle className="font-display">{title}</DialogTitle>
          <DialogDescription>Así verá el cliente el documento en PDF.</DialogDescription></DialogHeader>
        <div className="min-h-0 flex-1 overflow-auto rounded-md border bg-slate-100 p-3" data-testid="pdf-preview-pages">
          {err ? <p role="alert" className="p-4 text-sm text-rose-700" data-testid="pdf-preview-error">{err}</p>
            : pages ? pages.map((src, i) => <img key={i} src={src} alt={`Página ${i + 1}`} className="mx-auto mb-3 w-full max-w-3xl bg-white shadow" data-testid={`pdf-preview-page-${i + 1}`} />)
              : <div className="flex h-full items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-blue-600" /></div>}
        </div>
        <div className="flex justify-end">
          <Button variant="outline" onClick={() => downloadFile(path, null, filename).catch((e) => toast.error(errMsg(e)))} data-testid="pdf-preview-download"><Download className="mr-2 h-4 w-4" />Descargar PDF</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function PdfPreviewButton({ path, title, filename, testid = "pdf-preview-button" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} data-testid={testid}><Eye className="mr-2 h-4 w-4" />Vista previa PDF</Button>
      {open && <PdfDialog path={path} title={title} filename={filename} onClose={() => setOpen(false)} />}
    </>
  );
}
